/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';
import { Directive } from '@angular/core';

@Directive({
    selector: '[appIntegerValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: IntegerValidationDirective, multi: true }]
})

export class IntegerValidationDirective implements Validator {
    public validate(control: AbstractControl): { [key: string]: any } | null {
        return integerValidation(control);
    }
}

export function integerValidation(control: any): any {
    return (
        !control?.value ||
        (/^[0-9]+$/g).test(control?.value)
    ) ? null : { 'isIntegerValidator': 'invalid_integer' };
}
